import { Switch, Route } from 'react-router-dom'

import NovaAta from './components/NovaAta/'
import Login from './components/Login/index'
import Cadastro from './components/Cadastro/'
import Perfil from './components/Perfil/'
import Ata from './components/Ata/'
import NotFound from './components/NotFound'
import AtaVersao from './components/AtaVersao'
import AtaPdf from './components/AtaPdf'
import Update from './components/Update'
import Clientes from './components/Clientes'
import CadastroClientes from './components/CadastroClientes'
import EditarClientes from './components/EditarClientes'
import CadastrodeUsuario from './components/CadastrodeUsuario'
import PerfilUsuario from './components/PerfilUsuário'
import Usuarios from './components/Usuários'
import Projetos from './components/Projetos'
import CadastroDeProjeto from './components/CadastroDeProjeto'
import EditarProjeto from './components/EditarProjeto'
import PlanejamentoDeProjeto from './components/PlanejamentoDeProjeto'
import RelatorioDeProjeto from './components/RelatorioDeProjeto'
import DocumentosAta from './components/DocumentosAta'
import Orcamento from './components/Orcamento'
import HorasPorExecutante from './components/HorasPorExecutante'
import DailyAssignment from './components/DailyAssignment'

import EditarAta from './components/EditarAta'
import AtasExcluidas from './components/AtasExcluidas'
import Produtividade from './components/RelatorioDeProjeto/produtividade'
import PrivateRoute from './privateRoute'
import AtividadePdf from './components/AtividadePdf'
import TemplateDocumentos from './components/DocumentosAta/template'
import EditarUsuario from './components/EditarUsuario'

function Routes() {
    return (
            <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/cadastro" component={Cadastro} />
                <Route exact path="/perfil" component={Perfil} />
                <Route exact path="/nova-ata" component={NovaAta} />
                <Route exact path="/nova-ata/:ataId" component={NovaAta} />
                <Route exact path="/leitura-ata" component={Ata} />
                <Route exact path="/versao-ata" component={AtaVersao} />
                <Route exact path="/ata-pdf/:ataId" component={AtaPdf} />
                <Route exact path="/atividade-pdf/:mes/:ano" component={AtividadePdf} />
                <Route exact path="/clientes" component={Clientes} />
                <Route exact path="/cadastro-clientes" component={CadastroClientes} />
                <Route exact path="/editar-clientes" component={EditarClientes} />
                <Route exact path="/cadastro-de-usuario" component={CadastrodeUsuario} />
                <Route exact path="/editar-usuario/:id" component={EditarUsuario} />
                <Route exact path="/perfil-usuario" component={PerfilUsuario} />
                <Route exact path="/usuarios" component={Usuarios} />
                <Route exact path="/projetos" component={Projetos} />
                <Route exact path="/cadastro-de-projeto" component={CadastroDeProjeto} />
                <Route exact path="/editar-projeto" component={EditarProjeto} />
                <Route exact path="/planejamento-projeto" component={PlanejamentoDeProjeto} />
                <Route exact path="/relatorio-projeto" component={RelatorioDeProjeto} />
                <Route exact path="/orcamento" component={Orcamento} />
                <Route exact path="/horas-por-executante" component={HorasPorExecutante} />
                <Route exact path="/alocamento-diario" component={DailyAssignment} />
                <Route exact path="/documentos-ata" component={DocumentosAta} />
                <Route exact path="/editar-ata/:ataId" component={EditarAta} />
                <Route exact path="/atas-excluidas" component={AtasExcluidas} />
                <PrivateRoute
                    exact
                    path="/produtividade"
                    component={Produtividade}
                    useUser={true}
                />
                <Route 
                    exact
                    path="/template-documentos"
                    component={TemplateDocumentos} />
                
                <Route exact path="/update" component={Update} />

                <Route component={NotFound} />
                
            </Switch>
    )
}

export default Routes
